import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router";

import { API, graphqlOperation } from "aws-amplify";
import { userByActiveByLastName } from "../../../graphql/queries";
import { updateAuditAssignee } from "../../../graphql/audit/custom-mutations";
import { performUpdateInboundMini } from "../../../graphql/inbound/inboundCRUD";
import { performUpdateOutboundMini } from "../../../graphql/outbound/outboundCRUD";

import {
  Button,
  Edit,
  DateInput,
  FileInput,
  FormDataConsumer,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  TopToolbar,
  Toolbar,
  useNotify,
  useEditController,
} from "react-admin";
import { useForm } from "react-final-form";

import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { isFuture, isToday, isAfter, parse } from "date-fns";

import { logError } from "../../../utils/appUtils";
import {
  ApproveIcon,
  AttachFileIcon,
  LaunchIcon,
} from "../../../components/common/iconography";
import { BackButton } from "../../../components/common/BackButton";
import { FileField } from "../../../components/common/FileField";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import {
  ACCEPTED_FILES,
  FilePaths,
  MAX_FILES,
  Priorities,
  TaskStatus,
  TaskType,
  TaskTypes,
  TrueOrFalse,
} from "../../../utils/constants";
import { handleFileChange, saveRemoveFiles } from "../../../utils/fileUtils";
import { deepRedirect, getBackPath } from "../../../utils/utils";
import { TaskEditHelp } from "./TaskHelp";
import { TaskAside } from "./TaskAside";
import { DeepDeleteButton } from "./DeepDeleteButton";

const isTodayOrFutureDate = (value, allValues) => {
  const date = parse(value, "yyyy-MM-dd", new Date());
  const status = allValues.status;

  if (status > 20) return undefined;
  return value && (isToday(date) || isFuture(date))
    ? undefined
    : "Date must be in the future";
};

const validateForm = ({ dueDate, lateDate }) => {
  const errors = {};

  if (
    isAfter(
      parse(dueDate, "yyyy-MM-dd", new Date()),
      parse(lateDate, "yyyy-MM-dd", new Date()),
    )
  ) {
    errors.lateDate = ["Late date must be greater then due date"];
  }
  return errors;
};

const useStyles = makeStyles((theme) => ({
  link: {
    marginTop: theme.spacing(1.5),
  },
}));

const EditActions = (props) => (
  <TopToolbar>
    <HelpButton>
      <TaskEditHelp {...props} />
    </HelpButton>
    <BackButton {...props} />
  </TopToolbar>
);

const EditToolbar = (props) => {
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const { record, userOptions, backPath, history, notify } = props; // passing full props to DeepDeleteButton

  const transformApprove = (data) => {
    setIsSaving(true);

    return {
      ...data,
      status: 40,
      resolvedDate: new Date().toISOString(),
    };
  };

  const onSuccessApprove = (data) => {
    setIsSaving(false);
    notify("Task approved successfully", "success");
    deepRedirect(history, backPath);
  };

  const transform = async (data) => {
    setIsSaving(true);
    debugger;
    const { assignedTo, category, reference } = data;
    try {
      const user = userOptions.find((itm) => itm.id === assignedTo);
      data.assignedToName = user.fullName;

      if (category !== TaskType.GENERIC) {
        if (category === TaskType.AUDIT) {
          const toUpdateAudit = {
            id: reference,
            assignedTo: user.fullName,
          };

          await API.graphql(
            graphqlOperation(updateAuditAssignee, { input: toUpdateAudit }),
          );
        } else if (category === TaskType.ACCEPT_SHIPMENT) {
          const toUpdateInboundShippment = {
            id: reference,
            assignedTo: user.fullName,
          };

          await performUpdateInboundMini(toUpdateInboundShippment);
        } else if (category === TaskType.PROCESS_OUTBOUND_SHIPMENT) {
          const toUpdateOutboundShippment = {
            id: reference,
            assignedTo: user.fullName,
          };

          await performUpdateOutboundMini(toUpdateOutboundShippment);
        }
      }

      await saveRemoveFiles(
        record,
        data,
        "attachments",
        `${FilePaths.TASKS}/${data.id}`,
      );
    } catch (error) {
      setIsSaving(false);
      logError("task:TaskEdit:transform " + category, error, notify);
      return Promise.reject(error);
    }
    return data;
  };

  const onSuccess = ({ data }) => {
    setIsSaving(false);
    notify("Task updated successfully", "success");
    deepRedirect(history, backPath);
  };

  const onFailure = (error) => {
    setIsSaving(false);
    logError("task:EditToolbar:onFailure:Task Create", error, notify);
  };

  return (
    <Toolbar style={{ justifyContent: "space-between" }} {...props}>
      <div>
        <SaveButton
          {...props}
          label="Save"
          disabled={props.pristine || isDeleting}
          saving={isSaving}
          transform={transform}
          onSuccess={onSuccess}
          onFailure={onFailure}
        />
        {record?.status < 40 ? (
          <SaveButton
            {...props}
            label="Approve"
            icon={<ApproveIcon />}
            style={{ marginLeft: 16 }}
            submitOnEnter={false}
            undoable={false}
            disabled={isDeleting}
            saving={isSaving}
            transform={transformApprove}
            onSuccess={onSuccessApprove}
            onFailure={onFailure}
          />
        ) : null}
      </div>
      <DeepDeleteButton
        {...props}
        isSaving={isSaving}
        isDeleting={isDeleting}
        setIsDeleting={setIsDeleting}
      />
    </Toolbar>
  );
};

export const TaskEdit = (props) => {
  const notify = useNotify();
  const history = useHistory();
  const [userOptions, setUserOptions] = useState();
  const isComponentMounted = useRef(true);
  const { record } = useEditController(props);
  const backPath = getBackPath(props);

  useEffect(() => {
    debugger;
    if (isComponentMounted) getUsers();
    return () => (isComponentMounted.current = false);
  }, []);

  const getUsers = async () => {
    try {
      const response = await API.graphql(
        graphqlOperation(userByActiveByLastName, {
          reloadYardId: window.appUser?.reloadYardId,
          activeLastName: { beginsWith: { active: "true" } },
        }),
      );
      debugger;
      if (response.data.userByActiveByLastName.items.length > 0) {
        const users = response.data.userByActiveByLastName.items;
        let userList = users.map((itm) => ({
          id: itm.id,
          name: itm.fullName,
          fullName: itm.fullName,
        }));
        debugger;
        setUserOptions(userList);
      } else {
        logError("tasks:TaskEdit:getUsers:response", response, notify);
      }
    } catch (error) {
      logError("tasks:TaskEdit:getUsers", error, notify);
    }
  };

  return (
    <Edit
      {...props}
      title={<ForceTitle title="Edit Task" />}
      mutationMode="pessimistic"
      actions={<EditActions {...props} backPath={backPath} />}
      aside={<TaskAside />}
    >
      <SimpleForm
        validate={validateForm}
        toolbar={
          <EditToolbar
            {...props}
            record={record}
            userOptions={userOptions}
            backPath={backPath}
            history={history}
            notify={notify}
          />
        }
      >
        <TaskForm
          {...props}
          userOptions={userOptions}
          backPath={backPath}
          history={history}
        />
      </SimpleForm>
    </Edit>
  );
};

const TaskLinkField = ({ classes, history, record, backPath, ...props }) => {
  const handleProcess = () => {
    if (record.category === "ACCEPT_SHIPMENT") {
      deepRedirect(
        history,
        `/inboundShipments/${record.reference}`,
        backPath,
        {},
      );
    } else {
      deepRedirect(history, record.link, backPath, {});
    }
  };

  return record?.link ? (
    <Button
      label="Open"
      size="medium"
      color="primary"
      className={classes.link}
      onClick={handleProcess}
    >
      <LaunchIcon />
    </Button>
  ) : null;
};

const TaskForm = (props) => {
  const form = useForm();
  const notify = useNotify();
  const classes = useStyles();
  const { record, userOptions } = props;
  debugger;

  const validateDueDate = (value, allValues) => {
    // const fieldState = form.getFieldState("dueDate");
    // const isDirty = value !== fieldState?.initial;
    const isDirty = value !== record?.dueDate;
    const valid = isDirty ? isTodayOrFutureDate(value, allValues) : undefined;
    return valid;
  };

  const validateLateDate = (value, allValues) => {
    // const fieldState = form.getFieldState("lateDate");
    // const isDirty = value !== fieldState?.initial;
    const isDirty = value !== record?.lateDate;
    const valid = isDirty ? isTodayOrFutureDate(value, allValues) : undefined;
    return valid;
  };

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <Box flex={1} style={{ width: "100%" }}>
          <Box display={{ xs: "block", sm: "flex" }}>
            <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
              <SelectInput
                source="category"
                label="Task type"
                variant="outlined"
                fullWidth
                disabled
                choices={TaskTypes}
              />
            </Box>
            <Box flex={1}>
              <TaskLinkField classes={classes} {...props} />
            </Box>
          </Box>
          <Box display={{ xs: "block", sm: "flex" }}>
            <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
              <TextInput
                source="name"
                variant="outlined"
                fullWidth
                validate={required()}
              />
            </Box>
            <Box flex={1}>
              <SelectInput
                source="assignedTo"
                label="Assign To"
                variant="outlined"
                fullWidth
                choices={userOptions}
                validate={required()}
              />
            </Box>
          </Box>
          <TextInput
            source="description"
            label="Task description"
            formClassName={classes.fullWidthCol}
            variant="outlined"
            multiline
            minRows={2}
            fullWidth
            // validate={required()}
          />
          <Box display={{ xs: "block", sm: "flex" }}>
            <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
              <DateInput
                source="dueDate"
                label="Due date"
                variant="outlined"
                validate={[validateDueDate]}
                disabled={record?.status > 20}
                fullWidth
              />
            </Box>
            <Box flex={1}>
              <DateInput
                source="lateDate"
                label="Late date"
                variant="outlined"
                validate={[validateLateDate]}
                disabled={record?.status > 20}
                fullWidth
              />
            </Box>
          </Box>
          <Box display={{ xs: "block", sm: "flex" }}>
            <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
              <SelectInput
                choices={TrueOrFalse}
                source="allowReassign"
                label="Allow reassign"
                variant="outlined"
                fullWidth
              />
            </Box>
            <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
              <SelectInput
                choices={TaskStatus}
                source="status"
                variant="outlined"
                fullWidth
              />
            </Box>
            <Box flex={1}>
              <SelectInput
                choices={Priorities}
                label="Priority"
                source="priority"
                variant="outlined"
                fullWidth
              />
            </Box>
          </Box>
          <Box display={{ xs: "block", sm: "flex" }}>
            <Box flex={1}>
              <TextInput
                source="note"
                multiline
                minRows={2}
                disabled
                variant="outlined"
                fullWidth
                formClassName={classes.fullWidthCol}
              />
            </Box>
          </Box>
          <Box display={{ xs: "block", sm: "flex" }}>
            <Box flex={1}>
              <FileInput
                source="attachments"
                label="ATTACHMENTS"
                variant="outlined"
                fullWidth
                placeholder={
                  <p>
                    <AttachFileIcon fontSize="large" /> <br /> Drop file(s) to
                    upload, or click to select.
                  </p>
                }
                accept={ACCEPTED_FILES}
                multiple
                maxFiles={MAX_FILES}
                options={{ maxFiles: MAX_FILES }}
                onChange={(value) =>
                  handleFileChange("attachments", value, form, notify)
                }
              >
                <FileField source="src" title="title" target="_blank" />
              </FileInput>
            </Box>
          </Box>
        </Box>
      )}
    </FormDataConsumer>
  );
};
